export const APP_IS_LOADING = 'APP_IS_LOADING';
export const GET_DROPS = 'GET_DROPS';
export const GET_USER = 'GET_USER';
export const SHOW_MODAL = 'SHOW_MODAL';
export const GET_ACCOUNT_DATA = 'GET_ACCOUNT_DATA';
export const IS_LOADING = 'IS_LOADING';